import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { BackgroundImage, Card, Link } from 'pcln-design-system';
const CardLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "CardContainer__CardLink",
  componentId: "sc-swpyuz-0"
})(["&:hover{text-decoration:none;}"]);
const CardBackgroundImage = /*#__PURE__*/styled(BackgroundImage).withConfig({
  displayName: "CardContainer__CardBackgroundImage",
  componentId: "sc-swpyuz-1"
})(["min-height:", ";"], props => props.minHeight);
const FlexCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "CardContainer__FlexCard",
  componentId: "sc-swpyuz-2"
})(["display:flex;flex-direction:", ";height:100%;min-height:", ";justify-content:space-between;", " ", ""], props => props.flexDirection, props => props.minHeight, props => props.url ? `
        transition: background-color ${themeGet('timingFunctions.easeInOut')(props)} ${themeGet('duration.normal')(props)};

        &:hover {
          background-color: ${props.color ? props.color : 'rgba(0, 0, 0, 0.1)'};

          img {
            transform: scale(1.05);
            transition: transform ${themeGet('timingFunctions.easeInOut')(props)} ${themeGet('duration.normal')(props)};
          }
        }
      ` : '', props => props.showGradient ? `
        background-image: linear-gradient(to top,
        rgba(7, 6, 6, 0.6),
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.01) 50%,
        rgba(0, 0, 0, 0.01) 100%
      );` : '');
function LinkWrapper({
  ariaLabel,
  children,
  openInNewTab,
  href,
  onClick
}) {
  return href ? React.createElement(CardLink, {
    "aria-label": ariaLabel,
    href: href,
    target: openInNewTab ? '_blank' : '_self',
    width: 1,
    onClick: onClick
  }, children) : children;
}
const CardContainer = ({
  ariaLabel,
  backgroundImageUrl,
  backgroundImageAltText,
  children,
  height,
  minHeight,
  openInNewTab = true,
  url,
  onClick,
  ...props
}) => {
  const cardId = 'media-image-card';
  return React.createElement(LinkWrapper, {
    ariaLabel: ariaLabel,
    href: url,
    openInNewTab: openInNewTab,
    onClick: onClick
  }, backgroundImageUrl ? React.createElement(CardBackgroundImage, {
    "data-testid": 'background-image',
    id: 'mediacard-bgi',
    borderRadius: 'xl',
    image: backgroundImageUrl,
    alt: backgroundImageAltText || 'Media card image',
    minHeight: minHeight
  }, React.createElement(FlexCard, {
    "data-testid": cardId,
    height: height,
    minHeight: minHeight,
    url: url,
    ...props
  }, children)) : React.createElement(FlexCard, {
    "data-testid": cardId,
    height: height,
    minHeight: minHeight,
    url: url,
    ...props
  }, children));
};
export default CardContainer;